import styles from "./doctorHero.module.scss"
import classNames from "classnames"
import { CheckMark } from "../svgs/CheckMark"
import wave from "../../styles/LandingPage/Waves.module.scss"
import Button from "../components/Button/Button"
import SText from "../components/Text/SText"
import Image from "next/image"
import StyledText from "../typography/typography-component"
import { useTranslations } from "next-intl"

const DoctorHero = ({ onPrimaryButtonClick }: { onPrimaryButtonClick: () => void }) => {
  const t = useTranslations("index")

  return (
    <div className={styles.hero}>
      <Image
        className={styles.heroImageBigDesktop}
        alt={"hero image desktop"}
        src={"/images/hero_hcp/hero_hcp_desktop_12-16-2024.webp"}
        placeholder={"blur"}
        blurDataURL={"/images/hero_hcp/hcp_blur.webp"}
        quality={90}
        width={4000}
        height={1699}
        style={{
          maxWidth: "100%",
          height: "auto",
        }}
      />
      <Image
        className={styles.heroImageDesktop}
        alt={"hero image desktop"}
        src={"/images/hero_hcp/hero_hcp_desktop_12-16-2024.webp"}
        placeholder={"blur"}
        blurDataURL={"/images/hero_hcp/hcp_blur.webp"}
        quality={90}
        width={4000}
        height={1699}
        style={{
          maxWidth: "100%",
          height: "auto",
        }}
      />
      <Image
        className={styles.heroImageTablet}
        alt={"hero image tablet"}
        src={"/images/hero_hcp/hcp_hero_tablet.png"}
        width={842}
        height={696}
        style={{
          width: "100%",
          height: "auto",
          maxWidth: "100%",
        }}
      />
      <Image
        className={styles.heroImagePhone}
        alt={"hero image phone"}
        src={"/images/hero_hcp/hcp_hero_mobile.png"}
        width={376}
        height={430}
        style={{
          width: "100%",
          height: "auto",
          maxWidth: "100%",
        }}
      />
      <div className={classNames(styles.heroFlex)}>
        <div className={classNames(styles.col, styles.heroContent)}>
          <div className={classNames(styles.heroTitleBox, styles.marginBottomBigScreen, styles.heroTextAlign)}>
            <SText variant={"title"} color={"turq500"} className={styles.heroTitle}>
              {t("doctors.hero.title1")}
            </SText>
            <SText variant={"title"} color={"turq500"} className={styles.heroTitle}>
              {t("doctors.hero.title2")}
            </SText>
          </div>
          <div className={classNames(styles.heroBox)}>
            <div className={classNames(styles.heroBodyText)}>
              <CheckMark style={{ marginRight: "12px" }} />
              <SText variant={"body"} size={16} color={"green500"}>
                {t("doctors.hero.bullet1")}
              </SText>
            </div>
            <div className={classNames(styles.heroBodyText)}>
              <CheckMark style={{ marginRight: "12px" }} />
              <SText variant={"body"} size={16} color={"green500"}>
                {t("doctors.hero.bullet2")}
              </SText>
            </div>
            <div className={classNames(styles.heroBodyText)}>
              <CheckMark style={{ marginRight: "12px" }} />
              <SText variant={"body"} size={16} color={"green500"}>
                {t("doctors.hero.bullet3")}
              </SText>
            </div>
            <Button
              className={classNames(styles.marginSmall, styles.heroButton)}
              onClick={onPrimaryButtonClick}
              hug
              variant={"CTA"}
            >
              <StyledText variant={"cta"} color={"white"}>
                {t("doctors.hero.cta")}
              </StyledText>
            </Button>
          </div>
        </div>
      </div>
      <div className={wave.heroBottomWave}>
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            className={wave.shapeFill}
          ></path>
        </svg>
      </div>
    </div>
  )
}

export default DoctorHero
